import React from 'react';
import { Card, CardContent } from './ui/card';
import { Users, Clock, Wrench } from 'lucide-react';

const About = ({ currentLang, translations }) => {
  const stats = [
    { number: '10+', label: translations[currentLang].about.experience, icon: Clock },
    { number: '5000+', label: translations[currentLang].about.customers, icon: Users },
    { number: '15min', label: translations[currentLang].about.response, icon: Wrench }
  ];

  const features = [
    {
      key: 'professional',
      icon: Users,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      key: 'fast',
      icon: Clock,
      color: 'text-green-600', 
      bgColor: 'bg-green-50'
    },
    {
      key: 'modern',
      icon: Wrench,
      color: 'text-orange-600',
      bgColor: 'bg-orange-50'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            {translations[currentLang].about.title}
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed mb-8">
            {translations[currentLang].about.subtitle}
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            {translations[currentLang].about.description}
          </p>
        </div>

        {/* Stats Section */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {stats.map((stat, index) => {
            const IconComponent = stat.icon;
            return (
              <div key={index} className="text-center">
                <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                  <IconComponent className="w-12 h-12 text-blue-600 mx-auto mb-4" />
                  <div className="text-4xl font-bold text-gray-900 mb-2">{stat.number}</div>
                  <div className="text-gray-600 font-medium">{stat.label}</div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Features Section */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature) => {
            const IconComponent = feature.icon;
            return (
              <Card key={feature.key} className="hover:shadow-xl transition-shadow border-none">
                <CardContent className="p-8 text-center space-y-4">
                  <div className={`w-16 h-16 ${feature.bgColor} rounded-full flex items-center justify-center mx-auto`}>
                    <IconComponent className={`w-8 h-8 ${feature.color}`} />
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900">
                    {translations[currentLang].about.features[feature.key].title}
                  </h3>
                  
                  <p className="text-gray-600 leading-relaxed">
                    {translations[currentLang].about.features[feature.key].description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;